<template>
  <v-container fluid>
    <v-row justify="center" align="center" fluid class="pt-6 pb-6">
      <p class="display-2 text-center font-weight-bold indigo--text">Whose Choice is My Choice</p>
    </v-row>
    <v-row class="amber lighten-4" fluid pt-0 pb-0 pl-0 pr-0>
      <v-col cols="8" class="pa-2" align="center">
        <iframe
          width="80%"
          height="800"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/716678662&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"
        ></iframe>
        <div
          style="font-size: 10px; color: #cccccc;line-break: anywhere;word-break: normal;overflow: hidden;white-space: nowrap;text-overflow: ellipsis; font-family: Interstate,Lucida Grande,Lucida Sans Unicode,Lucida Sans,Garuda,Verdana,Tahoma,sans-serif;font-weight: 100;"
        >
          <a
            href="https://soundcloud.com/andreea-coscai"
            title="Andreea Coscai"
            target="_blank"
            style="color: #cccccc; text-decoration: none;"
          >Andreea Coscai</a> ·
          <a
            href="https://soundcloud.com/andreea-coscai/whose-choice-is-my-choice-podcast-by-andreea-coscai"
            title="Whose Choice is My Choice? (Podcast by Andreea Coscai)"
            target="_blank"
            style="color: #cccccc; text-decoration: none;"
          >Whose Choice is My Choice? (Podcast by Andreea Coscai)</a>
        </div>

        <v-container style="width:80%">
          <p class="text-sm-right font-weight-light">*credit for the art work goes to Phoebe Wahl!</p>
          <p class="text-sm-left">
            This audio piece discusses the topic of abortion from a cultural, social and political perspective. It introduces the situation of abortion in Communist and post-Communism Romania, as well as the situation of abortion in 21st century USA. By also including a religious standpoint, this piece tries to capture a meaningful understanding of opposing perspectives on the topic of abortion.
            This podcast was created for the "Reinventing Radio" course taught by Thom Loubet in Spring of 2019 at Bennington College.
          </p>
        </v-container>
      </v-col>
      <v-col cols="4">
        <AUTH :author="author" />
        <p class="text-sm-left">{{author.bio}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AUTH from "../../../Article/Author.vue";
export default {
  props: ["author"],
  components: {
    AUTH
  }
};
</script>